export default __webpack_public_path__ + "static/media/plus.ef99da89.svg";